// extracted by mini-css-extract-plugin
module.exports = {"container":"e4uFzbn0KoBdUa1NRdggE","icon":"_25MYO-RXeQ4pSuAti3szun"};